import Link from 'next/link';

import AppImage from '@/components/ui/AppImage';

export default function Footer() {
  const serviceLinks = [
    { id: 'footer_music', label: 'Music Shows', href: '/services#music' },
    { id: 'footer_animation', label: 'Animation', href: '/services#animation' },
    { id: 'footer_comedy', label: 'Comedy Shows', href: '/services#comedy' },
    { id: 'footer_coaching', label: 'Comedy Coaching', href: '/services#coaching' },
  ];

  const companyLinks = [
    { id: 'footer_about', label: 'About', href: '/about' },
    { id: 'footer_media', label: 'Media', href: '/media' },
    { id: 'footer_contact', label: 'Contact', href: '/contact' },
    { id: 'footer_services', label: 'Services', href: '/services' },
  ];

const socialLinks = [
    { id: 'social_facebook', name: 'Facebook', icon: 'facebook', href: 'https://www.facebook.com/roy.mbi.9' },
    { id: 'social_instagram', name: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/paragondelaftadian' },
    { id: 'social_tiktok', name: 'TikTok', icon: 'tiktok', href: 'https://www.tiktok.com/@paragondelaftadian' },
  ];
  return (
    <footer className="py-12 sm:py-20 px-4 sm:px-6 bg-white border-t border-border">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Services
            </h4>
            <div className="space-y-3">
              {serviceLinks?.map((link) => (
                <Link
                  key={link?.id}
                  href={link?.href}
                  className="block text-sm font-medium text-foreground hover:text-accent transition-colors break-words"
                >
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h4 className="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Company
            </h4>
            <div className="space-y-3">
              {companyLinks?.map((link) => (
                <Link
                  key={link?.id}
                  href={link?.href}
                  className="block text-sm font-medium text-foreground hover:text-accent transition-colors"
                >
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Social */}
          <div className="space-y-4">
            <h4 className="text-xs font-black uppercase tracking-widest text-muted-foreground">
              Connect
            </h4>
            <div className="flex gap-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.id}
                  href={social?.href}
                  className="w-10 h-10 rounded-full border border-border flex items-center justify-center hover:bg-accent hover:border-accent transition-all flex-shrink-0"
                  aria-label={social?.name}
                >
                  {social?.icon === 'facebook' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  )}
                  {social?.icon === 'instagram' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"/>
                    </svg>
                  )}
                  {social?.icon === 'tiktok' && (
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1.04-.1z"/>
                    </svg>
                  )}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl flex items-center justify-center overflow-hidden flex-shrink-0">
              <AppImage
                src="/assets/images/Screenshot_2026-02-02_181136-removebg-preview-1770214573040.png"
                alt="Paragon De Laftadian logo"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-base sm:text-xl font-black tracking-tight uppercase break-words">
              Paragon De Laftadian
            </span>
          </div>
          <div className="flex gap-6 sm:gap-8 text-[10px] font-black uppercase tracking-[0.2em] sm:tracking-[0.3em] text-muted-foreground">
            <Link href="/privacy" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
            <Link href="/terms" className="hover:text-foreground transition-colors">
              Terms
            </Link>
          </div>
        </div>

        <div className="mt-6 sm:mt-8 flex flex-col items-center gap-4">
          <p className="text-[9px] font-black uppercase tracking-[0.3em] sm:tracking-[0.5em] text-muted-foreground text-center">
            © 2026 Paragon De Laftadian. Built for creativity. ZENNA.
          </p>
        </div>
      </div>
    </footer>
  );
}